import { Scales } from '@phosphor-icons/react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 bg-[#050505] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center border border-blue-500/30 bg-blue-500/10">
              <Scales size={16} className="text-blue-500" weight="light" />
            </div>
            <span className="font-mono text-sm text-white/50">
              José Luis Vilaplana Villajos
            </span>
          </div>

          {/* Copyright */}
          <p className="font-mono text-xs text-white/30 text-center">
            © {currentYear} @tecnoabogado. Todos los derechos reservados.
          </p>

          {/* Links */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.vilaplanaabogados.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs text-white/50 hover:text-blue-500 transition-colors"
              data-testid="footer-link-despacho"
            >
              Vilaplana Abogados
            </a>
            <span className="text-white/20">/</span>
            <a
              href="https://tecnoabogado.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs text-white/50 hover:text-blue-500 transition-colors"
              data-testid="footer-link-blog"
            >
              Tecnoabogado
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
